export default __webpack_public_path__ + "static/media/08.cc9ef67c.jpg";